import { render, staticRenderFns } from "./PlansBillingsModal.vue?vue&type=template&id=cf70ba82&scoped=true"
import script from "./PlansBillingsModal.vue?vue&type=script&lang=js"
export * from "./PlansBillingsModal.vue?vue&type=script&lang=js"
import style0 from "./PlansBillingsModal.vue?vue&type=style&index=0&id=cf70ba82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf70ba82",
  null
  
)

export default component.exports